module.exports = __webpack_public_path__ + "media/images/sprangrulla_thumbnail-5605b7b2ecc1c773e28798fba37ecbcf.jpg";